import React from "react";
import { useTranslation } from "react-i18next";

import { Alert } from "stories/components";
import usePermissions from "hooks/usePermissions";

/**
 * Tells a read-only user why the page's actions are unavailable.
 *
 * Shown once at the top of a view, not above every table. Renders nothing for the
 * roles that can write, so it is safe to drop into any page that has write actions.
 */
const ReadOnlyBanner = ({ className }) => {
  const { isReadOnly } = usePermissions();
  const { t } = useTranslation();

  if (!isReadOnly) {
    return null;
  }

  return (
    <Alert variant="info" className={className} title={t("permission_read_only_title", "Sinulla on lukuoikeus tähän tiliin.")}>
      {t(
        "permission_read_only_text",
        "Voit tarkastella kaikkea dataa ja ottaa raportteja, mutta et tehdä muutoksia. Pyydä muokkausoikeutta tilin pääkäyttäjältä."
      )}
    </Alert>
  );
};

export default ReadOnlyBanner;
